import React from 'react';
import PropTypes from 'prop-types';
import Styles from './NotFound.module.scss';

const NotFound = ({ location }) => {
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.content}>
        <h1>
          404{' '}
          <span role="img" aria-label="404">
            ð¤§
          </span>
        </h1>
        <hr />
        <div>
          No match found for <code>{location.pathname}</code>
        </div>
        <div>
          <a href="/" alt="Click to go home">
            Click to go home
          </a>
        </div>
      </div>
    </div>
  );
};

NotFound.propTypes = {
  location: PropTypes.string
};

export default NotFound;
